/*eslint no-useless-constructor: "error"*/
"use strict";
export class ResponseModel {
  constructor(json) {
    this.init();
    if (json) {
      this.initWithJson(json);
    }
  }
  init() {
    this.status = false;
    this.result = null;
    this.message = "系統發生錯誤，請稍候再試試";
  }
  initWithJson(json) {
    this.status = json["status"];
    this.result = json["result"];
    this.message = json["message"];
  }
  get isSuccess() {
    return this.status
  }
}
